import { DocumentVersionORM } from 'src/types/types';
import { ListFieldConfig } from './util';

export const VALUE_MAX_TEXT_LINES = 5

export const SYSTEM_FIELD_CONFIGS: Record<string, ListFieldConfig> = {
  'ACTION_MENU': {
    fieldName: 'action',
    fieldLabel: '',
    fieldType: 'ACTION_MENU',
    width: 32,
  },
  'DOC_CREATED_AT': {
    dataType: 'date',
    fieldName: 'createdAt',
    fieldLabel: 'Created At',
    fieldType: 'DOC_MODEL',
    width: 100,
  },
  'DOC_CREATED_BY': {
    dataType: 'string',
    fieldName: 'createdBy',
    fieldLabel: 'Created By',
    fieldType: 'DOC_MODEL',
    width: 240,
  },
  'PUBLISHER_DOC_UPDATED_AT': {
    dataType: 'date',
    fieldName: 'publishedAt',
    altFieldName: 'createdAt',
    fieldResolver: (docVersion: DocumentVersionORM) => {
      const latestPublished = docVersion.relations.documentORM.relations.version.latestPublishedDocumentVersionORM
      // For Publisher list date column we have to pick the date based on certain conditions:
      // - If the doc is sealed use the publishedAt value
      // - If the latest doc version is a draft in progress use the createdAt value
      // - If the latest doc version is published use the publishedAt value
      const value = docVersion.meta.sealedStatus
        ? latestPublished?.model.publishedAt
        : docVersion.model.status !== 'PUBLISHED'
          ? docVersion.model.createdAt
          : docVersion.model.publishedAt

      return value
    },
    fieldLabel: 'Date',
    fieldType: 'MODEL',
    width: 100,
  },
  'BOOKMARK_DOC_UPDATED_AT': {
    dataType: 'date',
    fieldName: 'publishedAt',
    fieldResolver: (docVersion: DocumentVersionORM) => {
      return docVersion.relations.documentORM.meta.bookmark.createdAt
    },
    fieldLabel: 'Date',
    fieldType: 'MODEL',
    width: 100,
  },
  'DOC_UPDATED_AT': {
    dataType: 'date',
    fieldName: 'publishedAt',
    fieldLabel: 'Date',
    fieldType: 'MODEL',
    width: 100,
  },
  'DOC_UPDATED_BY': {
    dataType: 'string',
    fieldName: 'updatedBy',
    fieldLabel: 'Last Updated By',
    fieldType: 'MODEL',
    width: 240,
  },
  'FILE_TYPE': {
    dataType: 'string',
    fieldName: 'type',
    fieldLabel: 'Type',
    fieldType: 'MODEL',
    width: 50,
    fieldResolver: (docVersion: DocumentVersionORM) => {
      return docVersion.model.type === 'MP4' ? 'VIDEO' : docVersion.model.type
    },
  },
  'ID': {
    dataType: 'string',
    fieldName: 'id',
    fieldLabel: 'ID',
    fieldType: 'DOC_MODEL',
    width: 80,
  },
  'LABEL_STATUS_DOT': {
    dataType: 'string',
    fieldName: 'labelStatusDot',
    fieldLabel: '',
    fieldType: 'MODEL',
    width: 8,
  },
  'STATUS': {
    dataType: 'string',
    fieldName: 'status',
    fieldLabel: 'Status',
    fieldType: 'DOC_MODEL',
    width: 145,
  },
  'THUMBNAIL': {
    fieldName: 'thumbnail',
    fieldLabel: '',
    fieldType: 'MODEL',
    width: 140,
  },
  'TITLE': {
    dataType: 'string',
    fieldName: 'title',
    fieldLabel: 'Name',
    fieldType: 'MODEL',
    width: 384,
  },
  'CONTENT_SOURCE': {
    dataType: 'string',
    fieldName: 'source',
    fieldLabel: 'Content Source',
    fieldType: 'MODEL',
    width: 120,
    fieldResolver: (docVersion: DocumentVersionORM) => docVersion.meta.integration.source,
  },
}
